import styled from "styled-components";

export const FlexSpaceBetween = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const LoginButton = styled.a(() => ({
  width: "112px",
  fontSize: "16px",
  padding: "16px 36px",
  boxShadow: "none",

  "@media (max-width: 1012px)": {
    display: "none",
  },
}));

/* Header */
export const HeaderContainer = styled.header(({ theme }) => ({
  position: "sticky",
  top: "0",
  zIndex: "999",
  backgroundColor: theme.color.neutral["08"],
  boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",

  "a, ul li": {
    textDecoration: "none",
    listStyle: "none",
  },
}));

export const HeaderContent = styled.div(() => ({
  ...FlexSpaceBetween,
  gap: "44px",

  maxWidth: "1216px",
  width: "100%",
  padding: "0 15px",
  margin: "0 auto",

  "@media (max-width: 1012px)": {
    gap: "25px",
    padding: "16px 20px",
  },
}));

export const LogoContainer = styled.a(({ theme }) => ({
  ...FlexSpaceBetween,

  svg: {
    width: "108px",
    height: "35px",

    [theme.breakpoint.xl()]: {
      width: "175.95px",
      height: "56.6px",
    },
  },
}));

export const LinksList = styled.ul(() => ({
  ...FlexSpaceBetween,

  flex: "1",
  fontSize: "18px",
  margin: "0 auto",
  maxWidth: "100%",

  "@media (max-width: 1012px)": {
    display: "none",
  },
}));

export const LinksItem = styled.li(({ theme }) => ({
  "&:hover .submenu, &:hover .submenu-bg": {
    visibility: "visible",
    opacity: "0.9",
  },

  ":hover .icon": {
    transform: "rotateZ(-90deg)",
  },

  "& > a": {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.color.neutral["02"],

    [theme.breakpoint.lg()]: {
      fontCize: "16px",
      padding: "38px 12px",
    },

    [theme.breakpoint.xl()]: {
      fontSize: "18px",
      padding: "38px 16px 38px 16px",
    },
  },

  ".icon": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.color.brandPrimary.dark,
    transform: "rotateZ(90deg)",
    transition: "all 0.3s ease-in-out",
  },
}));

export const ActionsContainer = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "32px",

  "@media (max-width: 1012px)": {
    gap: "16px",
    flexDirection: "row-reverse",
  },

  svg: {
    cursor: "pointer",
  },

  ".hamburger": {
    display: "none",
    color: theme.color.brandPrimary.light,
    width: "28px",
    height: "28px",
    cursor: "pointer",

    "@media (max-width: 1012px)": {
      display: "flex",
    },
  },
}));

/* Submenu */
export const SubmenuBackground = styled.div(({ theme }) => ({
  position: "fixed",
  left: "0",
  top: "100px",
  width: "100%",
  backgroundColor: theme.color.neutral["07"],
  boxShadow:
    "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px",

  visibility: "hidden",
  opacity: "0",
  transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
}));

export const SubmenuContainer = styled.div(({ theme }) => ({
  position: "absolute",
  top: "110px",
  zIndex: "50",
  padding: "0px 20px 0px 20px",
  visibility: "hidden",
  opacity: "0",
  transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",

  "a, div": {
    fontSize: "18px",
    color: theme.color.brandPrimary.light,

    ":hover": {
      textDecoration: "underline",
    },
  },
}));

export const SubmenuLinksList = styled.ul(() => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "18px",
}));

export const SubmenuLinksItem = styled.li(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "20px",
  minHeight: "51px",
}));

export const Divider = styled.div(({ theme }) => ({
  width: "100%",
  height: "1px",
  backgroundColor: theme.color.line.medium,
}));
